// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"4ea7dde9","769":"46456cd9"}[chunkId] + ".chunk.js";
};